module.exports = __webpack_public_path__ + "img/134.e81e02f.svg";